import { render, staticRenderFns } from "./KnowledgeBaseAdmin.vue?vue&type=template&id=3e403be9&scoped=true"
import script from "./KnowledgeBaseAdmin.vue?vue&type=script&lang=ts"
export * from "./KnowledgeBaseAdmin.vue?vue&type=script&lang=ts"
import style0 from "./KnowledgeBaseAdmin.vue?vue&type=style&index=0&id=3e403be9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e403be9",
  null
  
)

export default component.exports